module.exports = __webpack_public_path__ + "img/pic_bokong.6e22d1ac.png";